import React, { useState } from 'react';
import { subscriptionMeta, subscriptionTitle } from './profileUtils.js';

export default function ComingUpList({ items, onRemove, emptyHint }) {
    const [pendingId, setPendingId] = useState(null);
    const [busyId, setBusyId] = useState(null);

    if (!items?.length) {
        return (
            <p className="profile-empty">{emptyHint}</p>
        );
    }

    return (
        <ul className="profile-coming-list">
            {items.map((sub) => {
                const title = subscriptionTitle(sub);
                const meta = subscriptionMeta(sub);
                const when = meta.split(' · ')[0];
                const rest = meta.split(' · ').slice(1).join(' · ');
                return (
                    <li key={sub.id} className="profile-coming-row">
                        <div className="profile-coming-when">{when}</div>
                        <div className="profile-coming-body">
                            <div className="profile-coming-title">{title}</div>
                            {rest ? <div className="profile-coming-meta">{rest}</div> : null}
                        </div>
                        {onRemove ? (
                            pendingId === sub.id ? (
                                <div className="profile-coming-confirm">
                                    <button
                                        type="button"
                                        className="profile-text-btn profile-text-btn--danger"
                                        disabled={busyId === sub.id}
                                        onClick={async () => {
                                            setBusyId(sub.id);
                                            try {
                                                await onRemove(sub.id);
                                            } finally {
                                                setBusyId(null);
                                                setPendingId(null);
                                            }
                                        }}
                                    >
                                        Remove
                                    </button>
                                    <button
                                        type="button"
                                        className="profile-text-btn"
                                        disabled={busyId === sub.id}
                                        onClick={() => setPendingId(null)}
                                    >
                                        Keep
                                    </button>
                                </div>
                            ) : (
                                <button
                                    type="button"
                                    className="profile-icon-btn"
                                    aria-label={`Remove reminder for ${title}`}
                                    onClick={() => setPendingId(sub.id)}
                                >
                                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                    </svg>
                                </button>
                            )
                        ) : null}
                    </li>
                );
            })}
        </ul>
    );
}
